import React from 'react';

const WindCompass = ({ degrees = 210, speed = "18" }) => {
  return (
    <div className="compass-widget" style={{ position: 'relative' }}>
      <span style={{ position: 'absolute', top: '8px', left: '8px', fontSize: '14px', zIndex: 5 }}>🇵🇭</span>
      <div className="compass-outer">
        {/* Cardinal Points */}
        <span className="n">N</span>
        <span className="e">E</span>
        <span className="s">S</span>
        <span className="w">W</span>

        {/* The Needle */}
        <div 
          className="needle" 
          style={{ transform: `rotate(${degrees}deg)` }}
        >
          <div className="needle-tip"></div>
        </div>
      </div>

      <div className="wind-data">
        <span className="speed-val">{speed}</span>
        <span className="unit">KTS</span>
      </div>
    </div>
  );
};

export default WindCompass;
